const getCategories = $.getJSON('/asset/api/getCategories/',{content: 'goods'})
const getPost = post_id => $.getJSON('/asset/api/getArticles/',{content: 'goods',post_id})

const makeCateTitle = (i,obj) => {
  const mode = location.search.replace(/^\?mode=(list|detail).*$/,'$1')||'list'
  let id = location.search.replace(/^\?mode=(list|detail)&(article|cat)=([\d]+)$/,'$3')
  $(obj).addClass('p-category-title')
  const $title = (href,name) => $(`
    <h3 class="p-category-title__name">
      <a href="${href}" class="notranslate">${name}</a>
    </h3>`)
  switch(mode){
    case 'list': {
      id = id||$(obj).find('a').attr('href').replace(/^(.*)cat=([\d]+)(.*)$/,'$2')
      const href = `/goods/?mode=list&cat=${id}`
      const name = $(obj).text()
      $(obj).html( $title(href,name)[0] ).addClass(`is-cat-${id}`)
      break;
    }
    case 'detail': {
      const $sp_title = $('.hs_entrytitle',obj)
      const $sp_catch = $('.catchcp',obj)
      $.when(getCategories,getPost(id)).done((cats,post) => {
        const this_cat = cats[0].filter(cat => cat.id == post[0][0].category)
        $(obj).html( $title(this_cat[0].href,this_cat[0].name)[0] ).addClass(`is-cat-${this_cat[0].id}`)
        if($.UA.is_mobile) $(obj).after($sp_title,$sp_catch)
      })
      break;
    }
  }
}

export default function GOODS() {
  
  $(() => {
    const loc = location
    // カテゴリタイトルHTML生成
    $('.element_list > .title, .element_detail > .title, .element_detail > .titleTxt').each(makeCateTitle) 

    // 詳細ページのcurrentMenu
    if(/mode=detail/.test(loc.search)) getPost(loc.search.replace(/^(.*)article=([\d]+)(.*)$/,'$2'))
    .done(data => {
      const catid = data[0].category
      let url = loc.pathname
      url += (data[0].id != 155)? `?mode=list&cat=${catid}`:`?mode=detail&article=${data[0].id}`
      $('.c-nav-goodsCat[data-plugin="currentMenu"]').currentMenu({default:999,mode:0, url})
    })

    $('.element_list .artloop h5>a').addClass('notranslate')
    $('.hs_entrytitle,.catchcp','.element_detail').addClass('notranslate')
  
  })


}